import A_sign from "./A.svg"
import B_sign from "./B.svg"
import C_sign from "./C.svg"
import D_sign from "./D.svg"
import E_sign from "./E.svg"
import F_sign from "./F.svg"
import G_sign from "./G.svg"
import H_sign from "./H.svg"
import I_sign from "./I.svg"
import J_sign from "./J.svg"
import K_sign from "./K.svg"
import L_sign from "./L.svg"
import M_sign from "./M.svg"
import N_sign from "./N.svg"
import O_sign from "./O.svg"
import P_sign from "./P.svg"
import Q_sign from "./Q.svg"
import R_sign from "./R.svg"
import S_sign from "./S.svg"
import T_sign from "./T.svg"
import U_sign from "./U.svg"
import V_sign from "./V.svg"
import W_sign from "./W.svg"
import X_sign from "./X.svg"
import Y_sign from "./Y.svg"
import Z_sign from "./Z.svg"

import A_sign_hand from "./Ahand.svg"
import B_sign_hand from "./Bhand.svg"
import C_sign_hand from "./Chand.svg"
import D_sign_hand from "./Dhand.svg"
import E_sign_hand from "./Ehand.svg"
import F_sign_hand from "./Fhand.svg"
import G_sign_hand from "./Ghand.svg"
import H_sign_hand from "./Hhand.svg"
import I_sign_hand from "./Ihand.svg"
import J_sign_hand from "./Jhand.svg"
import K_sign_hand from "./Khand.svg"
import L_sign_hand from "./Lhand.svg"
import M_sign_hand from "./Mhand.svg"
import N_sign_hand from "./Nhand.svg"
import O_sign_hand from "./Ohand.svg"
import P_sign_hand from "./Phand.svg"
import Q_sign_hand from "./Qhand.svg"
import R_sign_hand from "./Rhand.svg"
import S_sign_hand from "./Shand.svg"
import T_sign_hand from "./Thand.svg"
import U_sign_hand from "./Uhand.svg"
import V_sign_hand from "./Vhand.svg"
import W_sign_hand from "./Whand.svg"
import X_sign_hand from "./Xhand.svg"
import Y_sign_hand from "./Yhand.svg"
import Z_sign_hand from "./Zhand.svg"

export const SignImage = {
  A: A_sign,
  B: B_sign,
  C: C_sign,
  D: D_sign,
  E: E_sign,
  F: F_sign,
  G: G_sign,
  H: H_sign,
  I: I_sign,
  J: J_sign,
  K: K_sign,
  L: L_sign,
  M: M_sign,
  N: N_sign,
  O: O_sign,
  P: P_sign,
  Q: Q_sign,
  R: R_sign,
  S: S_sign,
  T: T_sign,
  U: U_sign,
  V: V_sign,
  W: W_sign,
  X: X_sign,
  Y: Y_sign,
  Z: Z_sign,
}

export const SignHandImage = {
  A: A_sign_hand,
  B: B_sign_hand,
  C: C_sign_hand,
  D: D_sign_hand,
  E: E_sign_hand,
  F: F_sign_hand,
  G: G_sign_hand,
  H: H_sign_hand,
  I: I_sign_hand,
  J: J_sign_hand,
  K: K_sign_hand,
  L: L_sign_hand,
  M: M_sign_hand,
  N: N_sign_hand,
  O: O_sign_hand,
  P: P_sign_hand,
  Q: Q_sign_hand,
  R: R_sign_hand,
  S: S_sign_hand,
  T: T_sign_hand,
  U: U_sign_hand,
  V: V_sign_hand,
  W: W_sign_hand,
  X: X_sign_hand,
  Y: Y_sign_hand,
  Z: Z_sign_hand,
}
